export default __webpack_public_path__ + "static/media/bg-title-02.f077afc6.jpg";